



























































































import { Vue } from "division-marker";
import { Component, Prop, Watch } from "division-marker";
import { DmShareds } from "saiten-base";
import addDays from "date-fns/add_days";
import dm_service from "@/shared/DmService";

class Condition {
  limited_on_from: string | null = null;
  limited_on_to: string | null = null;
  branch_id: string = "";
  user_id: string = "";
  // course: string = ''
  subject: string = "";

  group_limited_on: boolean = true;
  group_branch_id: boolean = false;
  group_user_id: boolean = false;
  group_subject: boolean = false;
}

@Component({ components: {}, mixins: [] })
export default class DmProgress extends Vue {
  @Prop() private msg!: string;
  search_results: any[] | null = null;
  condition = new Condition();
  searched_condition: Condition | null = null;
  result_cols: any[] | null = null;
  users: any[] | null = null;
  user_loaded = false;
  get consts_state() {
    return this.$store.state.consts;
  }
  get checked_results() {
    return this.search_results
      ? this.search_results.filter(x => x.checked)
      : [];
  }
  mounted() {
    // 検索初期値、localstorageから取得する。
    const condition = new Condition();
    condition.limited_on_from = DmShareds.DateUtil.to_yyyymmdd_hyphen(
      addDays(new Date(), -2)
    );
    condition.limited_on_to = DmShareds.DateUtil.to_yyyymmdd_hyphen(
      addDays(new Date(), +5)
    );
    const local_condition = JSON.parse(
      localStorage.getItem("progress#condition") || ("{}" as any)
    );
    // console.log(local_condition)
    this.condition = Object.assign(condition, local_condition);
    this.load_users();
    this.search();
  }

  async load_users() {
    const res = await DmShareds.Http.get("./api/dm/users");
    this.users = res.data;
    this.user_loaded = true;
  }

  // 検索処理
  async search() {
    try {
      this.search_results = null;
      this.searched_condition = Object.assign(new Condition(), this.condition);
      const data = await dm_service.progress_search(this.condition);
      console.log(data);
      const search_results = data.search_results;
      search_results.forEach((x: any) => (x.checked = false));
      this.search_results = search_results;

      const result_cols = [];
      if (this.searched_condition.group_limited_on)
        result_cols.push({ key: "limited_on", label: "納期日" });
      if (this.searched_condition.group_branch_id)
        result_cols.push({ key: "branch_name", label: "教室" });
      if (this.searched_condition.group_user_id)
        result_cols.push({ key: "user_id", label: "採点者ID" });
      if (this.searched_condition.group_subject)
        result_cols.push({ key: "subject", label: "科目" });
      this.result_cols = result_cols;
      localStorage.setItem(
        "progress#condition",
        JSON.stringify(this.condition)
      );
    } catch (err) {
      alert(err);
    }
  }
  // 全てチェック
  check_all() {
    if (this.search_results!.every(x => x.checked))
      this.search_results!.forEach(x => (x.checked = false));
    else this.search_results!.forEach(x => (x.checked = true));
    // this.search_results = this.search_results
  }
  assign_completed() {
    alert("振り分けを実施しました。");
    this.search_results = this.search_results!.filter(x => !x.checked);
  }
}
